
import { allGroup } from 'root/designer/constants';
import request from 'root/utils/request';
import config from 'root/config';

// 组件库列表
export async function getWidgetsByGroup(data, intl) {
  const { groupName } = data;
  return allGroup(intl)[groupName];
}

export async function queryIndustryApplicationLayout(layoutId) {
  return request(`${config.domainIndustryApplication}/layouts/${layoutId}?time=${Date.now()}`, {
    method: 'GET'
  });
}

export async function queryIndustryApplicationLayouts(pageId) {
  return request(`${config.domainIndustryApplication}/pages/${pageId}?kind=new`, {
    method: 'GET'
  });
}


export async function getServer({ dataSource, type, filters }) {
  return request(`${config.domainObject}/objectdata/query`,
    {
      method: 'POST',
      body: {
        dataSource,
        type,
        filters
      }
    });
}

export async function getBatchServer({ list }) {
  return request(`${config.domainObject}/objectdata/batchQuery`,
    {
      method: 'POST',
      body: {
        list
      }
    });
}

export async function updateIndustryApplicationLayout(data, pageId) {
  const context = Object.assign(JSON.parse(data.context), { version: 'v1.0' });
  return request(`${config.domainIndustryApplication}/layouts/${data.id}`, {
    method: 'PUT',
    body: {
      id: pageId,
      kind: data.kind,
      context: JSON.stringify(context)
    }
  });
}

export async function addIndustryApplicationLayout(data) {
  return request(`${config.domainIndustryApplication}/layouts`, {
    method: 'POST',
    body: data
  });
}

